import PerfectScrollbar from "perfect-scrollbar";

const TIMEOUT_FOR_SCROLLBAR_INIT = 2000;
export class Scrollbar {
    constructor(el) {
        this.el = el;
        new PerfectScrollbar(this.el);
    }
}

window.addEventListener("load", () => {
    const choicesCollection = document.getElementsByClassName("choices__list--dropdown");

    setTimeout(() => {
        if (choicesCollection) {
            let choicesLists = Array.from(choicesCollection);
            choicesLists.forEach(list => {
                const scrollList = list.querySelector(".choices__list");                
                new PerfectScrollbar(scrollList, {
                    wheelPropagation: false,
                });
            })
        }  
    }, TIMEOUT_FOR_SCROLLBAR_INIT);

    document.querySelectorAll(".js-scrollbar").forEach((el) => {
        new PerfectScrollbar(el);
    });

    document.querySelectorAll(".js-scrollbar-y").forEach((el) => {
        new PerfectScrollbar(el, {
            suppressScrollX: true,
            wheelPropagation: false,
        })
    });
});